import { useState, useCallback } from 'react';
import { ToastType } from './Toast';

interface Toast {
  id: string;
  type: ToastType;
  header: string;
  body: string;
  duration?: number;
}

export const useToast = () => {
  const [toasts, setToasts] = useState<Toast[]>([]);

  const addToast = useCallback(
    (toast: Omit<Toast, 'id'>) => {
      const id = Math.random().toString(36).substring(2, 9);
      setToasts((prevToasts) => [...prevToasts, { ...toast, id }]);
    },
    []
  );

  const removeToast = useCallback((id: string) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  }, []);

  const showToast = useCallback(
    (
      type: ToastType,
      header: string,
      body: string,
      duration?: number
    ) => {
      addToast({ type, header, body, duration });
    },
    [addToast]
  );

  return {
    toasts,
    showToast,
    removeToast,
  };
}; 